// Accessibility Enhancements
document.addEventListener('DOMContentLoaded', function() {
  // Enhance table headers for size charts
  function enhanceTableHeaders() {
    const sizeTables = document.querySelectorAll('.size-chart-table table');
    
    sizeTables.forEach(table => {
      // Check if table already has headers
      const hasHeaders = table.querySelector('thead') || table.querySelector('th');
      if (hasHeaders) return;
      
      // Get first row and convert to headers
      const firstRow = table.querySelector('tr');
      if (firstRow) {
        const cells = firstRow.querySelectorAll('td');
        cells.forEach(cell => {
          const th = document.createElement('th');
          th.innerHTML = cell.innerHTML;
          th.scope = 'col';
          cell.parentNode.replaceChild(th, cell);
        });
        
        // Wrap first row in thead
        const thead = document.createElement('thead');
        thead.appendChild(firstRow);
        table.insertBefore(thead, table.firstChild);
        
        // Add scope to first cell of each row in tbody
        const bodyRows = table.querySelectorAll('tbody tr');
        bodyRows.forEach(row => {
          const firstCell = row.querySelector('td');
          if (firstCell) {
            const th = document.createElement('th');
            th.innerHTML = firstCell.innerHTML;
            th.scope = 'row';
            firstCell.parentNode.replaceChild(th, firstCell);
          }
        });
      }
    });
  }
  
  // Add aria-live regions for dynamic messages
  function addAriaLiveRegions() {
    // Create a global aria-live region for announcements
    const liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'visually-hidden aria-live-region';
    document.body.appendChild(liveRegion);
    
    // Function to announce messages
    window.announceMessage = function(message) {
      liveRegion.textContent = message;
      // Clear after announcement
      setTimeout(() => {
        liveRegion.textContent = '';
      }, 1000);
    };
  }
  
  // Fix slider value announcements
  function enhanceSliderAnnouncements() {
    const priceSliders = document.querySelectorAll('.price-range-input');
    
    priceSliders.forEach(slider => {
      slider.addEventListener('change', function() {
        const value = this.value;
        const label = this.getAttribute('aria-label');
        const formattedValue = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(value);
        
        if (window.announceMessage) {
          window.announceMessage(`${label} changed to ${formattedValue}`);
        }
      });
    });
  }
  
  // Fix column button selected status
  function enhanceColumnButtons() {
    const columnButtons = document.querySelectorAll('.collection-filters-nav__cols-btn');
    
    columnButtons.forEach(button => {
      // Add aria-selected to indicate state
      if (button.classList.contains('active')) {
        button.setAttribute('aria-selected', 'true');
      } else {
        button.setAttribute('aria-selected', 'false');
      }
      
      button.addEventListener('click', function() {
        // Update all buttons
        columnButtons.forEach(btn => {
          btn.setAttribute('aria-selected', 'false');
        });
        this.setAttribute('aria-selected', 'true');
      });
    });
  }
  
  // Chat Widget Accessibility and Minimization
  function enhanceChatWidgets() {
    // Generic selectors for various chat widget implementations
    const chatSelectors = [
      '.chat-widget',
      '.chat-bubble',
      '.chat-icon',
      '.chat-button',
      '.chat-popup',
      '.chat-container',
      '.chat-widget-container',
      '.chat-widget-iframe',
      '.chat-widget-frame',
      '.chat-widget-embed',
      '.chat-widget-script',
      '.chat-widget-div',
      '.chat-widget-span',
      '.chat-widget-a',
      '.chat-widget-button',
      '[class*="chat"]',
      '[class*="Chat"]',
      '[class*="CHAT"]',
      '[id*="chat"]',
      '[id*="Chat"]',
      '[id*="CHAT"]'
    ];
    
    // Find all chat widgets
    const chatWidgets = document.querySelectorAll(chatSelectors.join(','));
    
    chatWidgets.forEach((widget, index) => {
      // Skip if already enhanced
      if (widget.hasAttribute('data-chat-enhanced')) return;
      
      // Mark as enhanced
      widget.setAttribute('data-chat-enhanced', 'true');
      
      // Add minimize/maximize button
      const toggleBtn = document.createElement('button');
      toggleBtn.className = 'chat-toggle-btn';
      toggleBtn.setAttribute('aria-label', 'Minimize chat widget');
      toggleBtn.setAttribute('title', 'Minimize chat widget');
      toggleBtn.innerHTML = '−';
      toggleBtn.style.cssText = `
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 24px;
        height: 24px;
        background: #000;
        color: white;
        border: none;
        border-radius: 50%;
        cursor: pointer;
        font-size: 12px;
        line-height: 1;
        z-index: 1001;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
      `;
      
      // Add click functionality
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (widget.classList.contains('minimized')) {
          // Maximize
          widget.classList.remove('minimized');
          toggleBtn.innerHTML = '−';
          toggleBtn.setAttribute('aria-label', 'Minimize chat widget');
          toggleBtn.setAttribute('aria-label', 'Minimize chat widget');
          
          if (window.announceMessage) {
            window.announceMessage('Chat widget maximized');
          }
        } else {
          // Minimize
          widget.classList.add('minimized');
          toggleBtn.innerHTML = '+';
          toggleBtn.setAttribute('aria-label', 'Maximize chat widget');
          toggleBtn.setAttribute('title', 'Maximize chat widget');
          
          if (window.announceMessage) {
            window.announceMessage('Chat widget minimized');
          }
        }
      });
      
      // Add button to widget
      widget.appendChild(toggleBtn);
      
      // Ensure widget is positioned correctly
      widget.style.position = 'fixed';
      widget.style.bottom = '1rem';
      widget.style.right = '1rem';
      widget.style.zIndex = '1000';
      
      // Add keyboard support
      widget.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          toggleBtn.click();
        }
      });
    });
    
    // Watch for dynamically added chat widgets
    const chatObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is a chat widget
            const isChatWidget = chatSelectors.some(selector => {
              try {
                return node.matches && node.matches(selector);
              } catch (e) {
                return false;
              }
            });
            
            if (isChatWidget) {
              setTimeout(() => enhanceChatWidgets(), 100);
            }
            
            // Check if the added node contains chat widgets
            const chatWidgetsInNode = node.querySelectorAll && node.querySelectorAll(chatSelectors.join(','));
            if (chatWidgetsInNode && chatWidgetsInNode.length > 0) {
              setTimeout(() => enhanceChatWidgets(), 100);
            }
          }
        });
      });
    });
    
    // Start observing
    chatObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // High Zoom Detection and Sticky Element Management
  function manageStickyElements() {
    // Check if we're at high zoom (400% at 1280px width)
    const isHighZoom = window.innerWidth >= 1280 && window.devicePixelRatio >= 4;
    const isLowWidth = window.innerWidth <= 320;
    
    if (isHighZoom || isLowWidth) {
      // Unstick all sticky elements
      const stickyElements = document.querySelectorAll(`
        .header,
        .global-header,
        .product-bar,
        .product-information-container,
        .child-navigation-header,
        .sticky,
        [class*="sticky"],
        [class*="fixed"]
      `);
      
      stickyElements.forEach(element => {
        element.style.position = 'relative';
        element.style.top = 'auto';
        element.style.zIndex = 'auto';
      });
      
      // Ensure main content is accessible
      const mainContent = document.querySelector('.main');
      if (mainContent) {
        mainContent.style.marginTop = '0';
        mainContent.style.paddingTop = '1rem';
      }
    }
  }
  
  // Handle window resize for zoom changes
  function handleZoomChanges() {
    let resizeTimeout;
    
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        manageStickyElements();
      }, 250);
    });
    
    // Initial check
    manageStickyElements();
  }
  
  // Initialize all enhancements
  enhanceTableHeaders();
  addAriaLiveRegions();
  enhanceSliderAnnouncements();
  enhanceColumnButtons();
  enhanceChatWidgets();
  handleZoomChanges();
  
  // Re-run table enhancements when size chart modal is opened
  const sizeChartObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        if (mutation.target.getAttribute('aria-hidden') === 'false') {
          setTimeout(enhanceTableHeaders, 100);
        }
      }
    });
  });
  
  const sizeChartModal = document.getElementById('size-chart');
  if (sizeChartModal) {
    sizeChartObserver.observe(sizeChartModal, { attributes: true });
  }
});